import axios from "axios";
import { backendURL } from "./consts";

export const getTrailLogs = async (token, params) => {
  const res = await axios.get(
    `${backendURL}/trailLogs/`,
    {
      headers:{
        token: `bearer ${token}`
      },
      params
    }
  );
  return res.data;
}